import {IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";

export const CloseButton = ({ closeToast }) => (
    <IconButton style={{color: "#fff"}} onClick={closeToast}>
        <Close />
    </IconButton>
);